import * as React from 'react';
import { isNullOrUndefined } from 'util';
import { Utils, DateFormatter, domain, domainVal, UiUtils, i18n, isAuth, NumberFormatter, } from 'arm-common';

class ApplicationData {
  constructor() {
    this.componentName = "[ComponentBase.js] ";
  }

  domainVal(codCampo, valCampo, defaultvalue) {

    let domini = domain(codCampo)
    if (!domini) {

      return defaultvalue ? {

        desDom: defaultvalue

      } : null;

    }

    let dom = defaultvalue;
    if (domini) {

      dom = domini.find(domain => domain.valCampo === valCampo);

    }

    if (dom) {

      return dom;

    }



    return {

      desDom: defaultvalue

    };
  }
}

export default ApplicationData = new ApplicationData;

